import { io } from "socket.io-client";

import React, { useContext, useEffect } from "react";
import "./Wrapper.scss";
import { BASE_URL, BASE_URL_SOCKET, BASE_URL_SOCKET_PATH, instance4 } from "App/constants";
import { defaultToastError, defaultToastNotif } from "App/utils/helpers";
import { WrapperCtx } from "./context/context";
import { getToken, getUserName } from "App/utils/cookies";
import { changeNotifikasiCount, changeNotifikasiList } from "./context/actions";
import { buildApiBaseUrl } from "App/utils/apiBaseUrl";
const socket = io(BASE_URL_SOCKET, {
  path: BASE_URL_SOCKET_PATH,
  auth: (cb) => {
    cb({ token: getToken() });
  },
});
const notif = new Audio(
  `${buildApiBaseUrl(BASE_URL, process.env.REACT_APP_PORT)}/audio/notif.mp3`
);

function WarpperWebSocket({ setNotification }) {
  const { dispatch } = useContext(WrapperCtx);
  // const notifCount = state.notifikasi_count;
  const urlGetNotif = "/notifikasi/notifikasi/list";

  const setNewNotif = async () => {
    try {
      const getNotif = await instance4.post(urlGetNotif, {
        to_user_notifikasi: getUserName(),
        jumlah: 5,
        halaman: 1,
      });
      const res = getNotif.data;
      if (res.status === 200) {
        dispatch(changeNotifikasiList(res.data));
        dispatch(changeNotifikasiCount(res.count_notif));
        return res.count_notif;
      } else {
        return "0";
      }
    } catch (error) {
      return defaultToastError(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    (() => {
      socket.on("connect", () => {
        console.log("Berhasil terhubung " + socket.id);
      });

      socket.on("sendNotifikasi", async (data) => {
        if (data.user === getUserName()) {
          const res = await setNewNotif();
          notif.play();
          setNotification(`🔴 (${res}) Notifikasi Baru`, 1000);
          defaultToastNotif(data.message);
        }
      });

      socket.on("disconnect", () => {
        // defaultToastError("Mohon periksa jaringan koneksi anda");
        console.log("Gagal terhubung ke web scoket");
      });
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    (() => {
      setNewNotif();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <></>;
}

export default WarpperWebSocket;
